export const DEFAULT_TEXT_TYPES = [
  "input", "textarea", "number", "address", 'select'
]
export const DEFAULT_DATE_TYPES = [
  "datepicker"
]